<script>
  import { contentfulImageUrlFor, srcSetFromWidths } from "$lib/utilities";
  export let data;

  let clazz = "";
  export { clazz as class };

  const heightMap = {
    wide: 24,
    narrow: 56,
    default: 40
  };

  function getImageDimensions(file) {
    const { width, height } = file?.details?.image || {};
    const aspectRatio = width / height;

    let h;
    if (aspectRatio > 4.5) {
      h = heightMap.wide;
    } else if (aspectRatio < 3) {
      h = heightMap.narrow;
    } else {
      h = heightMap.default;
    }
    return { height: h, width: h * aspectRatio };
  }
</script>

<a
  data-sveltekit-reload
  class="inline-flex items-center py-2 no-underline focus:bg-none focus:outline-cyan-700 {clazz}"
  href={data.destination.fields.url}
>
  <img
    alt={data.altText}
    srcset={srcSetFromWidths(data.image.fields.file.url, [250, 500])}
    sizes="250px"
    {...getImageDimensions(data.image.fields.file)}
    src={contentfulImageUrlFor(data.image.fields.file.url, { w: 250 })}
    loading="lazy"
  />
</a>
